// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2UbYz","dragIcon":"Choice_dragIcon__sM5Tu","left":"Choice_left__25CU1","input":"Choice_input__14SAc"};